let company;
const id = 'COMPANY_ID';
const DIOR = `${id}_DIOR`;
const EY = `${id}_EY`;

switch (process.env.PROJECT_ENV) {
  case 'production':
    company = {
      [DIOR]: ['8d6609e8-5150-46a7-b0ee-3110fb2d4b7c'],
      [EY]: ['29a40aa2-8bd6-49ea-bb4d-13a55b2a1edb'],
    };
    break;
  case 'preprd':
    company = {
      [DIOR]: [],
      [EY]: ['dc34aff6-2f0c-48e0-9513-d62515b9625a'],
    };
    break;
  case 'uat':
    company = {
      [DIOR]: [],
      [EY]: ['ba1841cf-d2d7-43d9-9d25-315bfe71eba2'],
    };
    break;
  case 'tst':
    company = {
      [DIOR]: [],
      [EY]: ['ba1841cf-d2d7-43d9-9d25-315bfe71eba2'],
    };
    break;
  default:
    company = {
      [DIOR]: ['ba1841cf-d2d7-43d9-9d25-315bfe71eba2'],
      [EY]: ['ba1841cf-d2d7-43d9-9d25-315bfe71eba2'],
    };
    break;
}
export default company;



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/configs/company.js
 **/